import { Fragment, type ReactNode } from 'react';

const URL_PATTERN = /\bhttps?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]]/g;

/** Rend les URL cliquables dans un texte brut, sans jamais interpréter de HTML. */
export function linkify(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    const index = match.index ?? 0;
    if (index > last) parts.push(text.slice(last, index));
    parts.push(
      <a
        key={index}
        href={match[0]}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#1a73e8] underline-offset-2 hover:underline dark:text-[#8ab4f8]"
        onClick={(event) => event.stopPropagation()}
      >
        {match[0]}
      </a>,
    );
    last = index + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts.map((part, i) => <Fragment key={i}>{part}</Fragment>);
}
